import { Link } from "react-router-dom";
import { XCircle, ArrowRight } from "lucide-react";

export default function PaymentCancel() {
  return (
    <div data-testid="payment-cancel-page" className="max-w-2xl mx-auto px-6 pt-32 pb-24 text-center">
      <XCircle size={56} style={{ color: "#cc7755", margin: "0 auto 1.5rem" }} />
      <p className="eyebrow mb-4">Checkout Cancelled</p>
      <h1 className="font-display text-5xl md:text-6xl mb-6 leading-[0.95]">
        No charge was made.
      </h1>
      <p className="text-base leading-relaxed mb-8" style={{ color: "var(--ink-muted)" }}>
        You closed the secure payment window. Your application is still saved — you can return
        and complete payment using any of our supported rails: cards, bank debit, Cash App Pay,
        Klarna, USDC stablecoin, or via a Web3 / NFT wallet.
      </p>
      <div className="flex gap-3 justify-center flex-wrap">
        <Link to="/franchise" className="btn-brass" style={{ justifyContent: "center" }}>
          Back to Franchise <ArrowRight size={14} />
        </Link>
        <Link to="/funding" className="btn-brass" style={{ justifyContent: "center", background: "transparent", color: "var(--brass)" }}>
          Back to Funding <ArrowRight size={14} />
        </Link>
      </div>
    </div>
  );
}
